import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { usePage } from 'context/PageContext';
import Hero from 'layouts/Hero';
import Blurb from 'components/partials/Blurb';

import 'styles/components/StorageTreasuresAbout.less';

const xxs = '/static/images/banners/about/AboutUs_xxs.jpg';
const xs = '/static/images/banners/about/AboutUs_xs.jpg';
const sm = '/static/images/banners/about/AboutUs_sm.jpg';
const md = '/static/images/banners/about/AboutUs_md.jpg';
const lg = '/static/images/banners/about/AboutUs_lg.jpg';

const blurb1Image = '/static/images/about/about-blurb1.jpeg';
const blurb2Image = '/static/images/about/about-blurb2.jpeg';
const blurb3Image = '/static/images/about/about-blurb3.jpeg';

interface StorageTreasuresAboutProps {
}

const StorageTreasuresAbout: React.FC<StorageTreasuresAboutProps> = () => {
    const { setPage, resetPage } = usePage();
    const [images] = useState([xxs, xs, sm, md, lg]);
    const [blurbs] = useState([
        {
            image: blurb1Image,
            title: 'Free Bidding and Viewing, Live and Online',
            content: `StorageTreasures.com is the world’s largest, most trusted online self-storage auction platform.
                The website hosts over 15,000 online auctions per month, and advertises live in-person auction schedules as well.
                The most comprehensive database of storage auctions is found here, and the site continues to grow as more
                and more storage operators make the transition online.`,
        },
        {
            image: blurb2Image,
            title: 'Founded and Managed by Experts',
            content: `StorageTreasures.com was founded by SSA members and self-storage professionals who have more than
                60 years of experience in the self-storage industry! OpenTech Alliance is the majority investor
                and has taken over management, since 2016. OpenTech is the leader in automation and call center
                services for the self-storage industry.`,
        },
        {
            image: blurb3Image,
            title: 'Giving Back Made Simple',
            content: `Proud partners with Charity Storage, a program that utilizes existing storage units and auctions to raise
                money to benefit their local community. The StorageTreasures domain provides features that make giving
                back simple for both Storage Operators and Auction Buyers.`,
        },
    ]);

    useEffect(() => {
        setPage({ 
            title: 'About StorageTreasures', 
            marginBottom: 'pageTitle',
            h1: 'About StorageTreasures', 
            description: undefined,
        });
        
        return () => {
            resetPage();
        };
    }, []);

    return (
        <div className="storagetreasures-about">
            <Hero
                hero_title="The Leader in the Industry"
                styles="hero"
                background="#2681A5"
                hero_description="The leader in the industry"
                images={images}
            />

            <div className="splashContent">
                <h2 className="splashHeader">Storage Auctions Simplified</h2>
                <p className="splashBody">
                    In 2011, StorageTreasures revolutionized the way in which the contents of self-storage units are marketed
                    and publicly auctioned after the lessee has failed to pay rent. The site fills the gap between the operational
                    systems that the industry currently utilizes and the public buyer who may be interested in the contents
                    of a unit that is going to auction. The tools StorageTreasures provides allow the storage industry not
                    only to comply with, but also to exceed the intent of state laws governing the self-storage industry, protecting
                    tenants and bidders alike.
                </p>
            </div>
            <div className="sub-container">
                <Blurb blurbs={blurbs} />
            </div>
        </div>
    );
};

export default connect(null, {})(StorageTreasuresAbout);